import styled from "styled-components";

import { theme } from "../../../themes/themes";
export const FormConfigContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 2em;
  display: grid;
  grid-template-columns: 100%;
  font-size: 14px;
  .left-scroll {
    height: 90% !important;
  }
`;

export const FormConfigWrapper = styled.div`
  display: grid;
  width: 100%;
  height: 250px;
  grid-template-columns: 100%;
  padding: 0 15px;
  grid-gap: 1.5em;
  @media only screen and (max-width: 768px) {
    height: fit-content;
  }
  .form-label {
    font-weight: 600;
  }
  .card-flex {
    background: none;
    border: none;
  }
  .font-w-600 {
    font-weight: 600;
    font-size: 16px;
  }
`;

export const FormConfigSectionWrapper = styled.div`
  display: grid;
  grid-auto-rows: 0.5fr 1fr;
  grid-gap: 0.2em;
  font-family: ${({ theme }) => theme.secondaryFontFamilyTwo};

  input {
    padding: 0.5em;
    width: 100%;
    height: 40px;
    border: 1px solid ${({ theme }) => theme.secondaryGrayLightOne};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input:focus {
    border-color: ${({ theme }) => theme.secondaryPinkLightOne};
    box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.secondaryPinkLightOne};
  }

  input::placeholder {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.secondaryGrayDarkOne};
  }

  label {
    font-weight: 400;
    font-size: 12px;
  }
`;

export const FormConfigHr = styled.hr`
  border: 1px solid ${({ theme }) => theme.secondaryGrayLightThree};
  width: 98%;
  margin-top: 0rem;
  margin-bottom: 0rem;
`;

export const IconMandatory = styled.span`
  color: ${({ theme }) => theme.secondaryRedOne};
`;

export const IconGuest = styled.img`
  width: 18.33px;
`;

export const CounterTotalUsers = styled.span`
  font-size: 36px;
`;

export const ContentSelect = styled.div`
  display: grid;
  grid-auto-rows: 0.5fr 1fr;
  grid-gap: 0.2em;
  font-family: ${({ theme }) => theme.secondaryFontFamilyTwo};
  padding: 0px 11px;
  ${(props) => (props.OnlyAssigned ? `z-index:3;` : ``)}
  ${(props) => (props.OnlyAssigned ? `background: white;` : ``)}
  border-radius: 9px;

  input {
    width: 100%;
    height: 30px;
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.secondaryGrayDarkOne};
  }

  label {
    font-weight: 400;
    font-size: 12px;
  }

  .css-1hb7zxy-IndicatorsContainer {
    div:nth-child(1) {
      display: ${(props) => (props.users ? "none" : "")};
    }
  }
  .css-xb97g8 {
    display: ${(props) => (props.users ? "none" : "")};
  }

  .css-1rhbuit-multiValue {
    background: ${({ theme }) => theme.button.primary};
    border-radius: 3px;
  }
  .css-12jo7m5 {
    color: #ffff;
    font-weight: 500;
  }
  .css-1okebmr-indicatorSeparator {
    visibility: hidden;
  }
  .css-tlfecz-indicatorContainer,
  css-tlfecz-indicatorContainer:hover {
    color: ${({ theme }) => theme.primary.purple};
  }
`;

export const List = styled.ul`
  padding-left: 1em;
  width: 100%;
  margin-top: 0px;
  margin-bottom: 0;
  ${(props) => props.OnlyAssigned && `z-index: 2;`}
  ${(props) => props.OnlyAssigned && `background: white;`}
  ${(props) => props.OnlyAssigned && `border-radius: 5px;`}
`;

export const Item = styled.li`
  list-style: none;
  line-height: 2em;
  display: grid;
  grid-template-columns: 90% 10%;
  border-radius: 7px;

  &:hover {
    background: #d2d2d2;
  }
  span {
    display: flex;
    float: right;
    margin-right: 1em;
    font-size: 23px;
    color: ${({ theme }) => theme.button.primary};
    cursor: pointer;
    align-items: center;
  }
  p {
    margin: 0 0 0 8px;
  }
`;

export const TextTitleList = styled.p`
  color: ${({ theme }) => theme.neutral.gray[2600]};
  font-size: 18px;
`;

export const ButtonLink = styled.a`
  cursor: pointer;
  opacity: ${(props) => (props.disabled ? `0.4` : `1`)};
`;

export const ButtonDay = styled.button`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.secondaryDarkOne};
  border-radius: 99px;
  border: none;
  width: 35px;
  height: 35px;
  &:hover {
    background-color: ${({ theme }) => theme.button.primary};
    color: ${({ theme }) => theme.primaryColorLight};
  }
`;

export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    boxShadow: isFocused ? "#ffbbdc33" : theme.neutral.gray[700],
    borderColor: theme.neutral.gray[700],
    ":hover": {
      ...styles[":hover"],
      borderColor: "#ffbbdc33",
    },
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#ffbbdc33" : data.color,
      ":hover": {
        ...styles[":hover"],
        backgroundColor: "#ffbbdc33",
      },
      color: isFocused ? theme.button.primary : data.color,
    };
  },
};

export const OptionWrapper = styled.div`
  margin: 0 2%;
  .MuiFormControlLabel-label {
    font-size: 14px;
  }
  .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${({ theme }) => theme.primary.purple};
  }
`;
